var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46095 3.00535C7.50339 3.09174 7.53143 3.18425 7.54398 3.27936L7.77601 6.72929L7.89119 8.46331C7.89238 8.64162 7.92035 8.8188 7.97421 8.98911C8.11332 9.31954 8.44796 9.52955 8.81203 9.51491L14.3598 9.15203C14.6 9.14807 14.832 9.23792 15.0047 9.40181C15.1486 9.53838 15.2415 9.71705 15.2708 9.90921L15.2806 10.0259C15.051 13.2048 12.7163 15.8563 9.54395 16.5407C6.37162 17.2252 3.11855 15.7793 1.55092 12.9882C1.09898 12.1773 0.816701 11.286 0.720644 10.3666C0.680516 10.0944 0.662847 9.81949 0.667808 9.54453C0.662854 6.13635 3.08988 3.18987 6.48727 2.47955C6.89617 2.41588 7.29701 2.63234 7.46095 3.00535Z",
    fill: "#8395A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.72514 0.0431631C13.525 0.139836 16.7187 2.8723 17.3335 6.55272L17.3276 6.57988L17.3108 6.61937L17.3132 6.72778C17.3045 6.87141 17.249 7.0096 17.1534 7.12122C17.0539 7.23749 16.9179 7.31667 16.7681 7.3474L16.6768 7.35994L10.2761 7.77465C10.0632 7.79565 9.85126 7.727 9.69293 7.58578C9.56098 7.46809 9.47663 7.30922 9.4528 7.13804L9.02319 0.746699C9.01571 0.725088 9.01571 0.70166 9.02319 0.680048C9.02906 0.503874 9.1066 0.337347 9.23851 0.217672C9.37041 0.097997 9.54567 0.0351468 9.72514 0.0431631Z",
    fill: "#8395A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.ebb501a1a056342b7c399b4ccab59691.svg";
export { ForwardRef as ReactComponent };